




export function alphabetizeArray(arr: string[], caseSensitive?: boolean)
{
    if(caseSensitive === false)
        return arr.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    else
        return arr.sort();
}





export function shuffleArray(arr: any[])
{
    for(let i = arr.length - 1; i > 0; i--)
    {
        const j = Math.floor(Math.random() * (i + 1));

        [arr[i], arr[j]] = [arr[j], arr[i]];
    }

    return arr;
}
